module.exports = __webpack_public_path__ + "img/txt3.286a6b18.png";